import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Criterials from '../general/criterials';
import {Table} from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';

import Inputmask from 'inputmask';

var Config = require('../../../config');

class Plasma extends Component{
	constructor(props){
		super(props);

		this.getData = this.getData.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.selectAll = this.selectAll.bind(this);
		this.onChecked = this.onChecked.bind(this);
		this.onSave = this.onSave.bind(this);
		this.removeFocus = this.removeFocus.bind(this);
		this.onReturn = this.onReturn.bind(this);

		var aux_date = new Date();

		this.state = {
			date: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			hour: "",
			box_number:"",

			plasma:[],
			checks:[],
			selectAll: false,
		}
	}

	componentDidMount(){
		var selector = document.getElementById('hour');
		var im = new Inputmask("--:--");
		im.mask(selector);

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				hour:hours,
			});
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		var campo = e.target.name;
		this.setState({
			[campo]: e.target.value
		});

		if(e.target.name === 'hour'){

			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		
		}else{
			setTimeout(function(){
				this.showCtrlError(campo);
			}.bind(this), 500);
		}	
	}

	getData(result){
		this.setState({
			plasma: result
		});

		result.map((r, i)=>{
			return this.setState({
				checks: [...this.state.checks, {id:r.unit.id, check:false}]
			})
		});

		setTimeout(function(){
			this.inputRef.focus();
		}.bind(this), 500);
	}

	onChecked(e){
		this.state.checks.map((u, j)=>{

			if(u.id === parseInt(e.target.id)){
				u.check = u.check ? false : true;	
			}
		});
		this.forceUpdate();
	}

	selectAll(e){
		if(e.target.checked){
			this.setState({
				selectAll:true
			})
		}else{
			this.setState({
				selectAll:false
			})
		}

		this.state.checks.map((u, j)=>{
			if(e.target.checked)	
				u.check = true;
			else
				u.check = false;	
			
		});
		this.forceUpdate();
	}

	onSave(){
		if(this.isValidDate(this.state.date)){
			var obj = {};
			var date = moment(this.state.date.split('-').reverse().join('/'), 'DD-MM-YYYY');
			var hour = moment(this.state.hour, 'h:mm a');

			obj.date = date.format('MM-DD-YYYY');;
			obj.hour = this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm');
			obj.box_number = parseInt(this.state.box_number);

			var parts=[];
			this.state.checks.map((c, i)=>{
				return c.check ?
						parts.push({
							unit_id: parseInt(c.id)
						})
					: null
			});

			obj.plasma_parts = parts;

			if(this.isValidForm()){
				if(obj.plasma_parts.length === 0){
					notify.show('Error, Tabla Incompleta','error');
				}else if(obj.hour === "Invalid date"){
					notify.show("Error, Hora invalida", 'error');
					
				}else{
					this.waiting_modal.handleShow('Guardando...');
					fetch(Config.default.apiGateway.URL+'plasma_process', {
						method:'post',
						body:JSON.stringify(obj),
						headers: new Headers({
							'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
							'Accept'		: 'application/json',
							'Content-Type'	: 'application/json'
						})
					}).then(res => {
						this.waiting_modal.handleClose();
						if(res.ok){
							return res.json();
						}else{
							res.text().then(function(result){
								swal('Error', result, 'error');
							})
						}

					})
					.then(response=>{
						if(response !== undefined){
							notify.show('Registro guardado', 'success');

							this.setState({
								plasma:[],
								checks:[],
								selectAll: false,
							});
						}
					});
				}

			}else{
				notify.show('Error, Campos Incompletos','error');
			}
		}else{
			notify.show('Error, Fecha no válida','error');
		}
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}		   
		  	}
	    });
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if (this.state[refName] === "") {
			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){	
  					if(form.elements[index + 1].getAttribute("disabled") === null){	
    					if(form.elements[index + 1].getAttribute("type") === 'checkbox'){
							form.elements[index + 1].focus();
							form.elements[index + 1].style.boxShadow = "0 0 5px 2px rgb(104, 173, 253)";
    					
    					}else{
    						form.elements[index + 1].focus();
    					}
    					
  					}else if(form.elements[index + 1].getAttribute("disabled") === ""){
    					form.elements[index + 2].focus();
    				}
      				
      			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	removeFocus(e){
  		e.target.style.boxShadow = "0 0 5px 2px rgb(255, 255, 255)";
  	}

  	onReturn(){
		this.props.history.push('/');
	}

	isValidDate(fecha){
		var valid = moment(fecha).format('MM-DD-YYYY');

		if(valid === 'Invalid date'){
			return false;
		}else{
			return true;
		}
	}

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						{t('sidebar.nav.process.plasma.MAIN')}
					</h5>
				</div>
				
				<form noValidate>
					<div className="col-xs-12">
						<fieldset>
							<legend style={{fontSize:"1.5em", marginBottom:"5px"}}>Búsqueda</legend>
							<Criterials {...this.props} validate={this.validateInput} sendData={this.getData} onRef={ref => (this.criterials = ref)} />
						</fieldset>

						<fieldset>
							<legend style={{fontSize:"1.5em", marginBottom:"10px"}}>Proceso</legend>

							<div className="col-xs-12 col-sm-9 col-sm-offset-2">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12" style={{width:"4.5%", padding:"0"}}>
										<span>Fecha</span>
									</div>
									<div className="col-xs-12 col-sm-2" style={{padding:"0 0 0 5px"}}>
										<input className="form-control" type="date" id="date" name="date" ref={(input) => { this.inputRef = input }}
											onChange={this.handleChange} value={this.state.date || ""} onKeyPress={(e) => this.validateInput(e)} required />
									</div>

									<div className="col-xs-12 col-sm-1" style={{paddingLeft:"19px"}}>
										<span>Hora</span>
									</div>
									<div className="col-xs-12 col-sm-2" style={{padding:"0", width:"14.2%"}}>
										<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
											data-inputmask-placeholder="-" value={this.state.hour || ""} onChange={this.handleChange}
											required onKeyPress={(e)=>this.validateInput(e)} className="form-control"/>
										{/*<input className="form-control hour-input" type="time" id="hour" name="hour" onChange={this.handleChange} 
											onKeyPress={(e) => this.validateInput(e)} value={this.state.hour || ""} required />*/}
									</div>

									<div className="col-xs-12" style={{width:"11%", paddingLeft:"15px"}}>
										<span>No. de caja</span>
									</div>
									<div className="col-xs-12" style={{width:"12.3%"}}>
										<input className="form-control" onKeyPress={(e) => this.validateInput(e)} type="number" id="box_number" name="box_number" value={this.state.box_number || ""} onChange={this.handleChange} required />
									</div>

								</div>

								<hr style={{width:"100%"}}/>
							</div>

							

							<div className="col-xs-12 col-sm-7 col-sm-offset-2">
								<div className="col-xs-12 ">
									<input className="form-check-input" onKeyPress={(e) => this.validateInput(e)} onBlur={this.removeFocus} name="selectAll" onChange={this.selectAll} checked={this.state.selectAll}  type="checkbox" />
									<span className="span-min" style={{paddingLeft:"5px"}}>Seleccionar Todos</span>
								</div>
								<div className="col-xs-12 ">
									
									<Table responsive hover>
										<thead>
											<tr>
												<th></th>
												<th>Donación</th>
												<th>Fecha</th>
											</tr>
										</thead>
										<tbody>
											{this.state.plasma.map((p, i)=>{
												return <tr key={i}>
														<td>
															<input type="checkbox" onChange={this.onChecked} onKeyPress={(e) => this.validateInput(e)}
																onBlur={this.removeFocus}
																id={this.state.checks[i] !== undefined ? this.state.checks[i].id : p.unit.id}
																checked={this.state.checks[i] !== undefined ? this.state.checks[i].check : false} />
														</td>
														<td>{p.unit.unit_number}</td>
														<td>{moment(p.donation_date).format('DD/MM/YYYY')}</td>
													</tr>
											})}
										</tbody>
									</Table>
								</div>
							</div>
						</fieldset>
					</div>
				</form>

				<Notifications />
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				<div className="col-xs-12" style={{textAlign:'center'}}>
		        	<div>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave} style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} onClick={this.onReturn} style={{margin:12}}/>
		        	</div>
		        </div>
			</div>
		)
	}
}

export default translate('translations')(Plasma)